// Declare the window object extension
declare global {
  interface Window {
    dataLayer: any[];
  }
}

const EventNames = {
  PAGE_VIEW: 'page_view',
  SIGN_IN: 'sign_in',
  SIGN_UP: 'sign_up',
  BEGIN_ORDER: 'begin_order',
  SUBMIT_CARD: 'submit_card',
  SUBMIT_BANK: 'submit_bank',
  SUBMIT_BILLING_ADDRESS: 'submit_billing_address',
  CONFIRM_ORDER: 'confirm_order',
  BEGIN_KYC: 'begin_kyc',
  COMPLETE_KYC: 'complete_kyc',
}

const sendGTMEvent = (payload: any) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      ...payload
    });
  }
}

export {
  EventNames,
  sendGTMEvent,
}